'use client';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import BaseButton, { type BaseButtonProps } from '@/app/_components/base/button';
import { cn } from '@/app/lib/utils/tailwindcss';

const modalButtonVariants = cva(
  // Base styles
  [
    'flex h-11 w-full items-center justify-center rounded cursor-pointer',
    'typo-heading-5',
    'disabled:cursor-not-allowed disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        primary: ['bg-button-modal-primary-default-bg text-button-modal-primary-default-text'],
        secondary: ['bg-button-modal-secondary-default-bg text-button-modal-secondary-default-text'],
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);

export type ModalButtonProps = BaseButtonProps & VariantProps<typeof modalButtonVariants>;

export default function ModalButton({ variant, className, ...props }: ModalButtonProps) {
  return <BaseButton className={cn(modalButtonVariants({ variant }), className)} {...props} />;
}

export { modalButtonVariants };
